var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10479_99902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.73 8.64998L14 6.53998C14.1274 6.46273 14.2359 6.358 14.3176 6.23345C14.3993 6.10889 14.4521 5.96766 14.4723 5.82006C14.4924 5.67246 14.4793 5.52224 14.4339 5.38035C14.3886 5.23847 14.3121 5.10851 14.21 4.99998L11 1.78998C10.8915 1.68795 10.7615 1.61145 10.6196 1.56607C10.4778 1.5207 10.3275 1.5076 10.1799 1.52772C10.0323 1.54785 9.8911 1.6007 9.76655 1.68241C9.64199 1.76411 9.53727 1.87261 9.46002 1.99998L7.30002 5.22998L2.81002 6.22998C2.70734 6.2549 2.61306 6.30648 2.53672 6.37952C2.46037 6.45256 2.40467 6.54447 2.37524 6.64595C2.34582 6.74742 2.34371 6.85487 2.36913 6.95742C2.39455 7.05998 2.4466 7.154 2.52002 7.22998L8.67002 13.39C8.74786 13.4604 8.84258 13.5096 8.94499 13.5327C9.0474 13.5558 9.15405 13.5521 9.25461 13.522C9.35518 13.4918 9.44625 13.4362 9.51903 13.3605C9.5918 13.2848 9.64381 13.1916 9.67002 13.09L10.73 8.64998Z",
    stroke: "#5A534D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.59 10.3799L1.5 14.4999",
    stroke: "#5A534D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10479_99902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinOff);
export default __webpack_public_path__ + "static/media/PinOff.75a0c3ac2a3e369028cfa88d1136e589.svg";
export { ForwardRef as ReactComponent };